// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import VueResource from "vue-resource";
import BsUI from "./components/packages/index";
import server from "./axios/api";
import i18n from "./i18n/i18n";
import "./filters";
import appApi from "./utils/appApi";

import {
  Field,
  Popup,
  Picker,
  Cell,
  CellGroup,
  Area,
  Toast,
  Dialog,
  Button,
  Form,
  RadioGroup,
  Radio
} from "vant";

// Vue.prototype.FHost = process.env.FAPI_HOST
// Vue.prototype.EHost = process.env.EAPI_HOST

Vue.use(Field)
  .use(RadioGroup)
  .use(Radio)
  .use(Form)
  .use(Button)
  .use(Popup)
  .use(Picker)
  .use(Cell)
  .use(CellGroup)
  .use(Area)
  .use(Toast)
  .use(Dialog);
Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.use(BsUI);

Vue.prototype.$server = server;
Vue.prototype.$appApi = appApi;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js